function parseMessage(message, cutoff) {
  let cutOff = cutoff || 9999
  let outputMessage
  try {
    if (typeof message === 'string') {
      outputMessage = message
    } else if (message == '' || message == null) {
      outputMessage = ''
    } else if (message[0].speech) {
      outputMessage = message[0].speech.slice(0, cutOff) + ((message[0].speech.length > cutOff) ? '...' : '')
    } else if (message[0].text) {
      outputMessage = message[0].text.text[0].slice(0, cutOff) + ((message[0].text.text[0].length > cutOff) ? '...' : '')
    } else if (message[0].quickReplies) {
      outputMessage = message[0].quickReplies.title ? message[0].quickReplies.title.slice(0, cutOff) + ((message[0].quickReplies.title.length > cutOff) ? '...' : '') : '[FACEBOOK_QUICKREPLY]'
    } else if (message[0].payload.facebook.attachment.type === 'template') {
      outputMessage = 'CAROUSEL'
    } else {
      outputMessage = '...'
    }
  } catch (err) {
    console.log('parse error', err)
    outputMessage = '...'
  }
  return outputMessage
}

exports.parseMessage = parseMessage



// WEBPACK FOOTER //
// ./src/filter/index.js